import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { NAV_BADGES_QUERY_KEY } from '../../lib/nav-badges';
import { trpc } from '../../lib/trpc';

/** Po zmianie w poczcie: wątki, szkice, stan skrzynek, Inbox (zdarzenia maili), Akceptacje i plakietki menu. */
export function useMailRefresh() {
  const utils = trpc.useUtils();
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      Promise.all([
        utils.mail.invalidate(),
        utils.inbox.invalidate(),
        utils.approvals.invalidate(),
        queryClient.invalidateQueries({ queryKey: NAV_BADGES_QUERY_KEY }),
      ]),
    [utils, queryClient],
  );
}

/** Stan skrzynek („Ostatnia synchronizacja: …”, utrata autoryzacji, symulacja); odświeżany co minutę. */
export function useMailStatus(enabled = true) {
  return trpc.mail.status.useQuery({}, { enabled, staleTime: 30_000, refetchInterval: 60_000 });
}
